(function () {
  // The script can be included by more than one section on the same page
  // (e.g. the tabs grid and the main product grid). Register the global
  // listener only once so a click doesn't advance the image twice.
  if (window.__cardMediaCarouselInit) return;
  window.__cardMediaCarouselInit = true;

  var ARROW_SELECTOR = '[data-card-media-prev],[data-card-media-next]';
  var SWIPE_THRESHOLD = 30; // px

  function imagesFor(wrapper) {
    var stack = wrapper.querySelector('[data-card-media-images]');
    if (!stack) return null;
    var images = Array.prototype.slice.call(stack.querySelectorAll('[data-media-index]'));
    return images.length > 1 ? images : null;
  }

  function activeIndex(images) {
    for (var i = 0; i < images.length; i++) {
      if (images[i].classList.contains('card__media-image--active')) return i;
    }
    return 0;
  }

  function show(images, index) {
    var next = ((index % images.length) + images.length) % images.length;
    images.forEach(function (img) {
      img.classList.toggle('card__media-image--active', img === images[next]);
    });
  }

  function cycle(wrapper, direction) {
    var images = imagesFor(wrapper);
    if (!images) return;
    show(images, activeIndex(images) + direction);
  }

  function arrowCycle(arrow) {
    var wrapper = arrow.closest('.product-card-wrapper');
    if (!wrapper) return;
    var dir = arrow.hasAttribute('data-card-media-prev') ? -1 : 1;
    cycle(wrapper, dir);
  }

  // Find an arrow at the click point even when another element (e.g. the card's
  // overlay link) is painted on top of it — this makes the fix independent of
  // CSS stacking order.
  function arrowAtEvent(event) {
    var target = event.target;
    var direct = target && target.closest ? target.closest(ARROW_SELECTOR) : null;
    if (direct) return direct;
    if (!document.elementsFromPoint) return null;
    var stack = document.elementsFromPoint(event.clientX, event.clientY);
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (!el || !el.closest) continue;
      var hit = el.closest(ARROW_SELECTOR);
      if (hit) return hit;
    }
    return null;
  }

  // Capture phase: run before the overlay link's click so preventDefault()
  // reliably cancels navigation to the product page.
  document.addEventListener(
    'click',
    function (event) {
      var arrow = arrowAtEvent(event);
      if (!arrow) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      arrowCycle(arrow);
    },
    true
  );

  // Touch swipe support for mobile
  function initTouchSwipe(wrapper) {
    var images = imagesFor(wrapper);
    if (!images) return;

    var startX = 0;
    var startY = 0;

    wrapper.addEventListener(
      'touchstart',
      function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );

    wrapper.addEventListener(
      'touchend',
      function (e) {
        var endX = e.changedTouches[0].clientX;
        var endY = e.changedTouches[0].clientY;
        var deltaX = endX - startX;
        var deltaY = endY - startY;

        // Only handle horizontal swipes (ignore vertical scrolling)
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > SWIPE_THRESHOLD) {
          e.preventDefault();
          cycle(wrapper, deltaX > 0 ? -1 : 1);
        }
      },
      { passive: false }
    );
  }

  // Init touch on all existing wrappers
  function initAll() {
    var wrappers = document.querySelectorAll('.product-card-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      if (!wrappers[i].dataset.cardswipeInit) {
        wrappers[i].dataset.cardswipeInit = 'true';
        initTouchSwipe(wrappers[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init for dynamically added cards (e.g. after filtering)
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      initAll();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
